import { Alert } from 'antd';
import { useAuth } from 'hooks';
import Export from '../../Export';
import { downloadType } from '../../Export/Summary/constants';

const LargeNetworkWarning = ({
  onExportNetwork,
  exportingNetwork,
  researcher,
}) => {
  const { user } = useAuth();
  return (
    <Alert
      style={{ margin: '10px 20px', textAlign: 'center' }}
      type='warning'
      message={
        user.isPartnerAccount ? (
          <span>
            This is a large network,&nbsp;
            <a
              href='https://scileads.com/get-started/'
              target='_blank'
              rel='noopener noreferrer'
            >
              Upgrade License
            </a>{' '}
            to access the Export feature for easier analysis
          </span>
        ) : (
          <span>
            This is a large network, we recommend exporting for easier analysis.
            <Export
              downloadType={downloadType.network}
              getQueryBody={() => ({
                researcherId: researcher?.researcherProfile?.id,
              })}
              disabled={exportingNetwork}
              onExport={onExportNetwork}
              style={{ marginLeft: 10 }}
            />
          </span>
        )
      }
    />
  );
};

export default LargeNetworkWarning;
